const readWriteModes = require('dbsm-common/src/dataset-configuration/readWriteModes')

const getCollectionName = (datasetConfig = {}) => datasetConfig.collectionName

const getPageSize = (datasetConfig = {}) => datasetConfig.pageSize

const isWriteOnly = (datasetConfig = {}) =>
  datasetConfig.readWriteType === readWriteModes.WRITE

module.exports.getCollectionName = getCollectionName
module.exports.getPageSize = getPageSize
module.exports.isWriteOnly = isWriteOnly



// WEBPACK FOOTER //
// ./dataset-config/datasetConfigParser.js